import React from "react";
import Navbar from "./Navbar";
import LogoAnimated from "./LogoAnimated";

function Header() {
  return (
    <header className="header-container">
      <div>
        <LogoAnimated aria-label="Farzad Cheshk's Logo"/>
      </div>
      <Navbar />
    </header>
  );
}

export default Header;
